import "reactjs-popup/dist/index.css";

import Popup from "reactjs-popup";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import TimezonePicker from "react-timezone";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  logout,
  getCountries,
  putAffiliate,
  updateUserInfo,
  postAffiliateTax,
  getAdminUserInfo,
  getAffiliateInfo,
  getGlobalLanguages,
  refreshCacheTeacher,
  postAffiliatePayment,
} from "../../store/middleware";
import ManageAccountTabs from "./Tabs";
import Header from "../../components/Header/NewHeader";
import DialogModal from "../../components/DialogModal";
import PhotoAvatar from "../../components/PhotoAvatar";
import SideMenu from "../../components/SideMenu/SideMenu";
import { setCheckout } from "../../store/slices/user.slice";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import linguitoPNG from "../../assets/images/icons/linguito.png";
import { SCButtonAddInput } from "../../components/Buttons/styles";
import { initLoading, endLoading } from "../../store/slices/generics.slice";
import Myaccount from "../../assets/images/icons/icon_myaccount_header.svg";
import { timeDisplayFormat as timeDisplayFormatFunction } from "../../utils/utils";
import InputForClassTool from "../../components/elements/NewInputs/InputForClassTool";

import { ManageAccountStyles } from "./Styles";
import ModalChangePassword from "../../components/ModalChangePassword";

function ManageAccount() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { plans } = useSelector((state) => state.studentReducer);
  const { user, checkout } = useSelector((state) => state.userReducer);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [timezone, setTimezone] = useState("");
  const [picture, setPicture] = useState(null);
  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [countryId, setCountryId] = useState(0);
  const [classTool, setClassTool] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [countries, setCountries] = useState([]);
  const [paymentID, setPaymentID] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [userPhones, setUserPhones] = useState([]);
  const [alerttitle, setAlertTitle] = useState("");
  const [openalert, setOpenAlert] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const [classToolId, setClassToolId] = useState("");
  const [paymentValue, setPaymentValue] = useState("");
  const [firstAccess, setFirstAccess] = useState(false);
  const [affiliateInfo, setAffiliateInfo] = useState(false);
  const [openmodalpass, setOpenModalPass] = useState(false);
  const [globallanguages, setGlobalLanguages] = useState([]);
  const [originalTimezone, setOriginalTimezone] = useState("");
  const [alertdescription, setAlertDescription] = useState("");
  const [timeDisplayFormat, setTimeDisplayFormat] = useState("12");
  const [userEmails, setUserEmails] = useState([{ email: "", notify: true }]);
  const [languages, setLanguages] = useState([{ languageId: 0, isNative: true }]);
  const [originalTimeDisplayFormat, setOriginalTimeDisplayFormat] = useState("12");
  const [bilingueNativo, setBilingueNativo] = useState({ bilingue: false, nativo: true });
  const [languagesTeacher, setLanguagesTeacher] = useState([{ languageId: 0, isNative: true }]);
  const [dialog, setDialog] = useState({ opened: false, title: "", message: "", onClose: () => {} });
  const [affiliateTaxInformations, setAffiliateTaxInformations] = useState({
    city: "",
    state: "",
    taxId: "",
    zipcode: "",
    address1: "",
    fullname: "",
    address2: "",
    birthDate: "",
    personType: "",
    taxIdType: "PF",
    whereLiveCountryId: "",
    // taxClassification: "",
    citizenshipCountryId: "",
  });

  const allTaxIdType = [
    { id: "SSN", name: "SSN (US Residents)" },
    { id: "CPF", name: "CPF (Brasil)" },
    { id: "RFC", name: "RFC (México)" },
    { id: "NIT", name: "NIT (Colombia)" },
    { id: "other", name: t("OTHER") },
  ];

  const callApi = async (showModal) => {
    await dispatch(initLoading());

    let respAffiliate = {};
    let urlCall = `admin/users/${user?.id}`;
    if (user?.role === "student") urlCall = `studentManagement/getbyuser/${user?.id}`;
    else if (user?.role === "teacher") urlCall = `teachermanagement/getbyuser/${user?.id}`;

    await dispatch(getAdminUserInfo(urlCall, true))
      .then(async (res) => {
        if (!res.success || !res.result.items || res.result.items.length === 0) return;

        const item = res.result?.items[0];

        if (user?.role === "student") {
          if (item.students && item.students.length > 0) {
            item.languages = item.students[0].studentLanguages;
            item.classTool = item.students[0].classTool;
            item.classToolId = item.students[0].classToolId;
          }
        } else if (user?.role === "teacher") {
          if (item.teachers && item.teachers.length > 0) item.languages = item.teachers[0].teacherLanguages;
        }

        if (user?.role === "student" || user?.role === "teacher" || user?.role === "coordinator") {
          if (item.languages && item.languages.length > 0) {
            item.languages.sort((x, y) => (x.isNative === y.isNative ? 0 : x.isNative ? -1 : 1));
          } else if (item.languages && item.languages.length === 0) {
            item.languages = [{ languageId: 0, isNative: true }];
          }
        }

        if (item.userPhones.length === 0) item.userPhones = [{ userPhoneTypeId: 15, phone: "" }];
        if (item.picture !== null) item.oldPicture = item.picture;

        let emailsForm = [];

        if (item?.email) {
          emailsForm.push({ email: decryptIfEncrypted(item?.email), notify: true });

          if (item?.userEmails.length > 0) {
            item?.userEmails.forEach(
              (item) =>
                item?.email !== item.email &&
                emailsForm.push({ email: decryptIfEncrypted(item.email), notify: item.notify }),
            );
          }
        }

        const responseUserPhones = item?.userPhones?.map((item) => {
          return { ...item, phone: decryptIfEncrypted(item.phone) };
        });

        const responseLanguages = item?.languages?.map((item) => {
          if (!item.language) return item;
          return { ...item, language: { ...item.language, name: decryptIfEncrypted(item.language.name) } };
        });

        setUserEmails(emailsForm);
        setLanguages(responseLanguages);
        setUserPhones(responseUserPhones);

        setPicture(item?.picture);
        setTimezone(item?.timezone);
        setStudents(item?.students);
        setTeachers(item?.teachers);
        setClassTool(item?.classTool);
        setClassToolId(item?.classToolId);
        setFirstAccess(item?.firstAccess);
        setOriginalTimezone(item?.timezone);
        setName(decryptIfEncrypted(item?.name));
        setEmail(decryptIfEncrypted(item?.email));
        setGender(decryptIfEncrypted(item?.gender));
        setTimeDisplayFormat(item?.timeDisplayFormat);
        setAddress(decryptIfEncrypted(item?.address));
        setCountryId(decryptIfEncrypted(item?.countryId));
        setBirthDate(decryptIfEncrypted(item?.birthDate));
        setOriginalTimeDisplayFormat(item?.timeDisplayFormat);

        if (user?.role === "student") {
          setBilingueNativo({
            bilingue: item?.students[0]?.typeTeacherPreference === "bilingual" && true,
            nativo: item?.students[0]?.typeTeacherPreference === "native" && true,
          });

          if (user?.firstAccess) {
            if (!handleValidateB2BOrB2C()) {
              setOpenAlert(true);
              setAlertTitle(t("THANKS"));
              setAlertDescription(t("WELCOME_TO_LINGO"));
            }
          }
        }

        if (user?.role === "teacher") {
          const responseTeacherLanguages = item?.teachers[0]?.teacherLanguages.map((item) => {
            return { ...item, language: { ...item.language, name: decryptIfEncrypted(item.language.name) } };
          });

          setLanguagesTeacher(responseTeacherLanguages);
          setPaymentID(decryptIfEncrypted(item?.teachers[0]?.paymentId));
          setPaymentType(decryptIfEncrypted(item?.teachers[0]?.paymentType));
          setPaymentValue(decryptIfEncrypted(item?.teachers[0]?.paymentValue));
        }

        respAffiliate = await dispatch(getAffiliateInfo(user?.id));

        if (respAffiliate) {
          setRedirect(false);
          setAffiliateInfo(respAffiliate);
          setPaymentType(respAffiliate?.affiliatePaymentMethods[0]?.provider);
          setLanguages([{ languageId: respAffiliate?.nativeLanguageId, isNative: true }]);
          setAddress(decryptIfEncrypted(respAffiliate.affiliateTaxInformations[0]?.address1));
          setPaymentID(decryptIfEncrypted(respAffiliate?.affiliatePaymentMethods[0]?.providerUser));
          setAffiliateTaxInformations({
            city: decryptIfEncrypted(respAffiliate?.affiliateTaxInformations[0]?.city),
            state: decryptIfEncrypted(respAffiliate?.affiliateTaxInformations[0]?.state),
            zipcode: decryptIfEncrypted(respAffiliate?.affiliateTaxInformations[0]?.zipcode),
            address1: decryptIfEncrypted(respAffiliate?.affiliateTaxInformations[0]?.address1),
            address2: decryptIfEncrypted(respAffiliate?.affiliateTaxInformations[0]?.address2),
            taxIdType: decryptIfEncrypted(respAffiliate?.affiliateTaxInformations[0]?.taxIdType),
            personType: decryptIfEncrypted(respAffiliate?.affiliateTaxInformations[0]?.personType),
            taxId: decryptIfEncrypted(respAffiliate?.affiliateTaxInformations[0]?.taxId.replace(/[^0-9]/g, "")),
            whereLiveCountryId: decryptIfEncrypted(respAffiliate?.affiliateTaxInformations[0]?.whereLiveCountryId),
            citizenshipCountryId: decryptIfEncrypted(respAffiliate?.affiliateTaxInformations[0]?.citizenshipCountryId),
          });
        }

        if (showModal) {
          setOpenAlert(true);
          setAlertTitle(t("SAVE_FORM_TITLE"));
          setAlertDescription(t("SAVE_FORM_DESCRIPTION"));
        }
      })
      .catch((err) => console.log("ERRO GET USERS ", err))
      .finally(() => dispatch(endLoading()));

    if (!showModal) {
      await dispatch(getCountries()).then((res) => setCountries(res));
      await dispatch(getGlobalLanguages()).then((res) => setGlobalLanguages(res));
    }
  };

  const closeAlert = () => {
    setOpenAlert(false);
    setRedirect(false);
  };

  const addEmail = (e) => {
    e.preventDefault();
    setUserEmails((state) => [...state, { email: "", notify: true }]);
  };

  const addPhone = (e) => {
    e.preventDefault();
    setUserPhones((state) => [...state, { userPhoneTypeId: "", phone: "" }]);
  };

  const removeEmail = (e, findIndex) => {
    e.preventDefault();
    setUserEmails(userEmails.filter((value, index) => index !== findIndex));
  };

  const addLanguage = (e) => {
    e.preventDefault();
    setLanguages((state) => [...state, { languageId: 0, isNative: false }]);
  };

  const removeLanguage = (e, findIndex) => {
    e.preventDefault();
    setLanguages(languages.filter((value, index) => index !== findIndex));
  };

  const removePhone = (e, findIndex) => {
    e.preventDefault();
    setUserPhones(userPhones.filter((value, index) => index !== findIndex));
  };

  const handleValidateB2BOrB2C = () => {
    return students && !!students[0]?.studentB2bs.length;
  };

  const handleChangeList = async (e, index) => {
    e.preventDefault();

    const { name, value } = e.target;

    if (name === "email") {
      //if (index === 0) setEmail(value);
      setUserEmails((state) => state.map((item, i) => (i === index ? { ...item, email: value } : item)));
    }

    if (name === "notify") {
      setUserEmails((state) => state.map((item, i) => (i === index ? { ...item, notify: !item.notify } : item)));
    }

    if (name === "phone") {
      setUserPhones((state) => state.map((item, i) => (i === index ? { ...item, phone: value } : item)));
    }

    if (name === "userPhoneTypeId") {
      setUserPhones((state) => state.map((item, i) => (i === index ? { ...item, userPhoneTypeId: value } : item)));
    }

    if (name === "language") {
      setLanguages((state) =>
        state.map((item, i) =>
          i === index ? { languageId: Number(value), isNative: index === 0 ? true : false } : item,
        ),
      );
    }
  };

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    switch (target.name) {
      case "name":
        setName(value);
        setAffiliateTaxInformations((state) => ({ ...state, fullname: value }));
        break;
      case "email":
        setEmail(value);
        break;
      case "gender":
        setGender(value);
        break;
      case "birthDate":
        setBirthDate(value);
        setAffiliateTaxInformations((state) => ({ ...state, birthDate: value }));
        break;
      case "countryId":
        setCountryId(value);
        setAffiliateTaxInformations((state) => ({ ...state, whereLiveCountryId: Number(value) }));
        break;
      case "classToolId":
        setClassToolId(value);
        break;
      case "address":
        setAddress(value);
        setAffiliateTaxInformations((state) => ({ ...state, address1: value }));
        break;
      case "classTool":
        setClassTool(value);
        break;
      case "citizenshipCountryId":
        setAffiliateTaxInformations((state) => ({ ...state, citizenshipCountryId: Number(value) }));
        break;
      case "address2":
        setAffiliateTaxInformations((state) => ({ ...state, address2: value }));
        break;
      case "city":
        setAffiliateTaxInformations((state) => ({ ...state, city: value }));
        break;
      case "zipcode":
        setAffiliateTaxInformations((state) => ({ ...state, zipcode: value }));
        break;
      case "taxIdType":
        setAffiliateTaxInformations((state) => ({ ...state, taxIdType: value }));
        break;
      case "taxId":
        setAffiliateTaxInformations((state) => ({ ...state, taxId: value }));
        break;
      case "state":
        setAffiliateTaxInformations((state) => ({ ...state, state: value }));
        break;
      default:
        break;
    }
    // validateForm();
  };

  const validateForm = () => {
    if (user?.role === "customerService" || user?.role === "companyManager") return true;

    if (!name) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("NAME") }));

      return false;
    } else if (!email) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("EMAIL") }));

      return false;
    } else if (!gender) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("GENDER") }));

      return false;
    } else if (!birthDate || moment(birthDate).isAfter(moment().subtract(1, "year"))) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("BIRTH_DATE") }));

      return false;
    } else if (!userPhones[0].phone) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("TELEPHONE") }));

      return false;
    } else if (userPhones[0]?.userPhoneTypeId === "15") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("TYPE") }));

      return false;
    } else if (!timezone) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("TIMEZONE") }));

      return false;
    } else if (countryId === 0) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("COUNTRY") }));

      return false;
    } else if (!address) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("ADDRESS") }));

      return false;
    } else if (!handleValidateB2BOrB2C() && languages[0].languageId === 0) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("NATIVE_LANGUAGE") }));

      return false;
    } else return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      let formData = {
        name: name.toString(),
        email: email.toLowerCase(),
        address: address,
        countryId: Number(countryId),
        id: user?.id,
        role: user?.role,
        gender: gender,
        birthDate: birthDate,
        timezone: timezone,
        userEmails: userEmails,
        userPhones: userPhones,
        classTool: classTool,
        classToolId: classToolId,
        timeDisplayFormat,
      };

      let urlCall = `admin/users`;
      if (user?.role === "student") {
        urlCall = `studentManagement/updatePersonalInformation`;

        let newlanguages = languages;
        if (newlanguages && languages.length > 0) {
          const nativeLanguages = newlanguages.filter((l) => l.isNative);
          if (nativeLanguages.length !== 1) {
            for (let index = 0; index < newlanguages.length; index++) {
              newlanguages[index].isNative = false;
            }
            newlanguages[0].isNative = true;
          }
        }
        if (students && students.length > 0) {
          let student = students[0];
          student.studentLanguages = newlanguages;
          student.languages = newlanguages;
          formData.student = student;
          student.classTool = classTool;
          student.classToolId = classToolId;

          formData.typeLanguage = bilingueNativo.bilingue ? "bilingual" : "native";
          formData.firstAccess = false;
        }
      } else if (user?.role === "teacher") {
        urlCall = `teachermanagement`;

        formData.payment = {
          paymentId: paymentID,
          paymentType: paymentType,
          paymentValue: paymentValue,
        };

        let teacher = {
          id: teachers[0]?.id,
          isActive: teachers[0]?.isActive,
          demoClass: teachers[0]?.demoClass,
          firstClass: teachers[0]?.firstClass,
          languages: teachers[0]?.teacherLanguages.map((item) => ({
            isNative: item.isNative,
            languageId: item.languageId,
            levels: item.teacherLanguageLevels.map((item) => item.teacherLevel.levelId),
          })),
        };

        formData.teacher = teacher;
        delete formData.classTool;
        delete formData.classToolId;
      }

      formData.userEmails?.map((email) => {
        delete email.id;
        delete email.userId;
        delete email.updatedAt;
      });

      formData.userPhones.map((phone) => {
        delete phone.id;
        delete phone.userId;
        delete phone.updatedAt;
      });

      try {
        if (affiliateInfo) {
          formData.firstAccess = false;

          const bodyAffiliate = {
            id: affiliateInfo?.id,
            nativeLanguageId: languages[0].languageId,
            considerYourselfInfluencer: affiliateInfo?.considerYourselfInfluencer,
            followingTotalAllPlatforms: affiliateInfo?.followingTotalAllPlatforms,
            termsAccepted: affiliateInfo?.termsAcceptedsAt === null ? false : true,
          };

          const bodyAffiliatePayment = {
            provider: paymentType,
            providerUser: paymentID,
            userId: affiliateInfo.userId,
            affiliateId: affiliateInfo.id,
          };
          await dispatch(putAffiliate(bodyAffiliate))
            .then(async () => {
              if (
                paymentType !== affiliateInfo?.affiliatePaymentMethods[0]?.provider ||
                paymentID !== affiliateInfo?.affiliatePaymentMethods[0]?.providerUser
              ) {
                paymentType !== "" && paymentID !== "" && dispatch(postAffiliatePayment(bodyAffiliatePayment));
              }
              if (
                affiliateTaxInformations.address1 !== affiliateInfo?.affiliateTaxInformations[0]?.address1 ||
                affiliateTaxInformations.address2 !== affiliateInfo?.affiliateTaxInformations[0]?.address2 ||
                affiliateTaxInformations.citizenshipCountryId !==
                  affiliateInfo?.affiliateTaxInformations[0]?.citizenshipCountryId ||
                affiliateTaxInformations.city !== affiliateInfo?.affiliateTaxInformations[0]?.city ||
                affiliateTaxInformations.taxId !== affiliateInfo?.affiliateTaxInformations[0]?.taxId ||
                affiliateTaxInformations.taxIdType !== affiliateInfo?.affiliateTaxInformations[0]?.taxIdType ||
                affiliateTaxInformations.whereLiveCountryId !==
                  affiliateInfo?.affiliateTaxInformations[0]?.whereLiveCountryId ||
                affiliateTaxInformations.state !== affiliateInfo?.affiliateTaxInformations[0]?.state ||
                affiliateTaxInformations.zipcode !== affiliateInfo?.affiliateTaxInformations[0]?.zipcode ||
                affiliateTaxInformations.fullname !== affiliateInfo?.affiliateTaxInformations[0]?.fullname ||
                affiliateTaxInformations.birthDate !== affiliateInfo?.affiliateTaxInformations[0]?.birthDate
              ) {
                dispatch(
                  postAffiliateTax({
                    ...affiliateTaxInformations,
                    userId: affiliateInfo?.userId,
                    affiliateId: affiliateInfo?.id,
                  }),
                );
              }

              await dispatch(updateUserInfo(urlCall, JSON.parse(JSON.stringify(formData)), "manageAccount"))
                .then((res) => {
                  if (!res || !res?.data?.success) return;

                  callApi(true);

                  if (timezone !== originalTimezone) {
                    setRedirect(false);
                    setOpenModalPass(false);
                    setOpenAlert(false);
                    setDialog({
                      opened: true,
                      title: t("MODAL_RELOAD_SUBJECT"),
                      message: t("MODAL_RELOAD_MESSAGE"),
                      buttonLabel: "LOGIN",
                      onClose: () => dispatch(logout()),
                    });
                  }
                  if (timeDisplayFormat !== originalTimeDisplayFormat) {
                    if (user?.role === "teacher") {
                      dispatch(refreshCacheTeacher(user?.teacherId));
                    }

                    setRedirect(false);
                    setOpenModalPass(false);
                    setOpenAlert(false);
                    setDialog({
                      opened: true,
                      title: t("MODAL_RELOAD_SUBJECT_TIME"),
                      message: t("MODAL_RELOAD_MESSAGE_TIME"),
                      buttonLabel: "LOGIN",
                      onClose: () => dispatch(logout()),
                    });
                  }
                })
                .catch((error) => {
                  setOpenAlert(true);
                  setAlertTitle(t("ERROR"));
                  setAlertDescription(error?.[0]?.message);
                });
            })
            .catch((error) => {
              setOpenAlert(true);
              setAlertTitle(t("ERROR"));
              setAlertDescription(error?.response?.data.error[0]?.message);
            });
        } else {
          dispatch(updateUserInfo(urlCall, JSON.parse(JSON.stringify(formData)), "manageAccount")).then(async (res) => {
            if (!res || !res?.data?.success) return;

            await callApi(true);

            if (timezone !== originalTimezone) {
              setRedirect(false);
              setOpenModalPass(false);
              setOpenAlert(false);
              setDialog({
                opened: true,
                title: t("MODAL_RELOAD_SUBJECT"),
                message: t("MODAL_RELOAD_MESSAGE"),
                buttonLabel: "LOGIN",
                onClose: () => dispatch(logout()),
              });
            }
            if (timeDisplayFormat !== originalTimeDisplayFormat) {
              if (user?.role === "teacher") {
                dispatch(refreshCacheTeacher(user?.teacherId));
              }

              setRedirect(false);
              setOpenModalPass(false);
              setOpenAlert(false);
              setDialog({
                opened: true,
                title: t("MODAL_RELOAD_SUBJECT_TIME"),
                message: t("MODAL_RELOAD_MESSAGE_TIME"),
                buttonLabel: "LOGIN",
                onClose: () => dispatch(logout()),
              });
            }
            dispatch(setCheckout(false));
          });
        }
      } catch (error) {
        if (error) {
          setOpenAlert(true);
          setAlertTitle(t("ERROR"));
          setAlertDescription(t("ERROR_DIALOG"));
        }
      }
    }
  };

  const openModalPassword = (e) => {
    e.preventDefault();
    setOpenModalPass(true);
  };

  const handleClickBilingueNativo = (e, type) => {
    e.preventDefault();

    if (type === "bilingue") setBilingueNativo({ bilingue: true, nativo: false });
    else setBilingueNativo({ bilingue: false, nativo: true });
  };

  const ruleDisplayNativeBilingue = () => {
    let newArrayLang = [];
    for (let i = 0; i < plans?.length; i++) {
      plans[i]?.studentPlanLanguages?.map((lang) =>
        plans[i].student?.studentLevelGrades.filter((grade) => {
          if (grade.lingoLanguageId === lang.lingoLanguageId)
            newArrayLang.push({ flag: lang.lingoLanguage.flag, level: grade.level.level });
        }),
      );
    }

    return newArrayLang.some(
      (item) => (item.flag === "US" || item.flag === "FR") && !["A0", "A1"].includes(item.level),
    );
  };

  const handleSelectHours = (e, value) => {
    e.preventDefault();
    setTimeDisplayFormat(value);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    callApi(false);
    // eslint-disable-next-line
  }, []);

  const nativeLanguage = languages?.find((item) => item.isNative);
  const validationLanguageNative = nativeLanguage ? nativeLanguage?.languageId : null;

  let dataNew = moment(new Date()).utc().tz(timezone);
  let dataTimeZone = moment(dataNew).format(timeDisplayFormatFunction(timeDisplayFormat));

  if (redirect && !checkout) return <Navigate to="/" />;

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          t={t}
          typeIcon="custom"
          initLoadingBoolean={false}
          title={t("MANAGE_ACCOUNT_TITLE")}
          icon={<img src={Myaccount} alt={t("MANAGE_ACCOUNT_TITLE")} />}
        />

        <ManageAccountStyles>
          {user?.firstAccess && (
            <div className="container">
              <h3>
                {user?.role === "affiliate"
                  ? ""
                  : handleValidateB2BOrB2C()
                  ? t("FIRST_ACESS_TEXT_B2B")
                  : t("FIRST_ACESS_TEXT")}
              </h3>
            </div>
          )}

          <div className="tabs">
            <ManageAccountTabs />

            <div className="content">
              <div className="card">
                <PhotoAvatar userID={user?.id} picture={picture} setPicture={setPicture} />

                <form className="formulario">
                  <div className="wrapperBlock">
                    <h4 className="textBlock">{t("PERSONAL_DATA")}</h4>
                  </div>

                  <div>
                    <label>{t("NAME")}</label>
                  </div>
                  <input
                    required
                    id="name"
                    type="text"
                    name="name"
                    value={name}
                    onChange={handleChange}
                    placeholder={t("NAME_PLACEHOLDER")}
                  />

                  {userEmails.length &&
                    userEmails?.map((item, index) => {
                      return (
                        <div key={index}>
                          <div>
                            <label htmlFor={"email" + index}>{index === 0 ? t("EMAIL") : t("EXTRA_EMAIL")} </label>
                          </div>
                          <div className="notification">
                            <input
                              required
                              type="text"
                              name="email"
                              value={item.email}
                              id={"email" + index}
                              className="newemail inputMobile"
                              readOnly={index === 0 && user?.role !== "CompanyManager" ? true : false}
                              placeholder={index === 0 ? t("EMAIL_PLACEHOLDER") : t("EXTRA_EMAIL_PLACEHOLDER")}
                              onChange={(e) => {
                                if (index === 0) handleChange(e);
                                handleChangeList(e, index);
                              }}
                            />

                            <div className="switchBox">
                              <div className="switch__container">
                                <input
                                  name="notify"
                                  type="checkbox"
                                  id={"notify" + index}
                                  checked={item.notify}
                                  className="switch switch--shadow"
                                  onChange={(e) => handleChangeList(e, index)}
                                />
                                <label className="labelNotify" htmlFor={"notify" + index}>
                                  <span>{t("NOTIFICATION")}</span>
                                  <span className="doubleClick">{t("DOUBLE_CLICK")}</span>
                                </label>
                              </div>
                              {index > 0 ? (
                                <SCButtonAddInput id={index} name="remove" onClick={(e) => removeEmail(e, index)}>
                                  {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                                </SCButtonAddInput>
                              ) : (
                                <SCButtonAddInput name="addemail" onClick={(e) => addEmail(e)}>
                                  {t("ADD_EMAIL")} +
                                </SCButtonAddInput>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}

                  <div className="inputs">
                    <div className="lineInputs">
                      <div>
                        <label>{t("GENDER")}</label>
                      </div>
                      <select name="gender" value={gender} onChange={handleChange}>
                        <option value="">{t("SELECT")}</option>
                        <option value="notInformed">{t("NOT_INFORMED")}</option>
                        <option value="male">{t("MALE")}</option>
                        <option value="female">{t("FEMALE")}</option>
                      </select>
                    </div>

                    <div className="lineInputs">
                      <div>
                        <label>{t("BIRTH_DATE")}</label>
                      </div>

                      <input type="date" id="date" name="birthDate" value={birthDate} onChange={handleChange} />
                    </div>
                  </div>

                  {userPhones.map((item, index) => {
                    return (
                      <div key={index} className="inputs">
                        <div className="lineInputs">
                          <div>
                            <label>{t("TELEPHONE")}</label>
                          </div>
                          <input
                            name="phone"
                            id={"phone" + index}
                            className="inputMobile"
                            required={index === 0}
                            placeholder={t("PHONE_PLACEHOLDER")}
                            value={decryptIfEncrypted(item.phone)}
                            onChange={(e) => handleChangeList(e, index)}
                          />
                        </div>
                        <div className="lineInputs">
                          <div>
                            <label htmlFor={"userPhoneTypeId" + index}>{t("TYPE")}</label>
                          </div>
                          <select
                            className="inputMobile"
                            name="userPhoneTypeId"
                            id={"phoneType" + index}
                            value={item.userPhoneTypeId || 15}
                            onChange={(e) => handleChangeList(e, index)}
                          >
                            <option value="15">{t("SELECT")}</option>
                            <option value="1">{t("COMMERCIAL")}</option>
                            <option value="2">{t("RESIDENCIAL")}</option>
                            <option value="3">{t("CELLPHONE")}</option>
                            <option value="4">{t("WHATSAPP")}</option>
                          </select>
                        </div>
                        {index === 0 && (
                          <div className="lineInputs">
                            <SCButtonAddInput name="addphone" onClick={(e) => addPhone(e)}>
                              {t("BTN_ADD_TEL")} +
                            </SCButtonAddInput>
                          </div>
                        )}
                        {index > 0 && (
                          <SCButtonAddInput id={index} name="remove" onClick={(e) => removePhone(e, index)}>
                            {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                          </SCButtonAddInput>
                        )}
                      </div>
                    );
                  })}

                  <div className="wrapperBlock">
                    <h4 className="textBlock">{t("COUNTRY")}</h4>
                  </div>

                  <div className="inputs">
                    <div className="lineInputs">
                      <div>
                        <label>{t("COUNTRY")}</label>
                      </div>
                      <select name="countryId" value={countryId} onChange={handleChange}>
                        <option value="0">{t("SELECT")}</option>
                        {countries.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {affiliateInfo && (
                      <div className="lineInputs">
                        <div>
                          <label>{t("CITIZENSHIP_COUNTRY")}</label>
                        </div>
                        <select
                          onChange={handleChange}
                          name="citizenshipCountryId"
                          value={affiliateTaxInformations.citizenshipCountryId}
                        >
                          <option value="0">{t("SELECT")}</option>
                          {countries.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>

                  <div className="wrapperSelectHours">
                    <div>
                      <label>{t("SELECT_TIME_FORMAT")}</label>
                    </div>

                    <div className="wrapperSelectHoursButons">
                      <button
                        onClick={(e) => handleSelectHours(e, "12")}
                        className={`buttonSelectHours ${timeDisplayFormat === "12" && "buttonSelectHoursActive"}`}
                      >
                        12 {t("HOURS")}
                      </button>
                      <button
                        onClick={(e) => handleSelectHours(e, "24")}
                        className={`buttonSelectHours ${timeDisplayFormat === "24" && "buttonSelectHoursActive"}`}
                      >
                        24 {t("HOURS")}
                      </button>
                    </div>
                  </div>

                  <div className="inputs">
                    <div className="lineInputs timezoneCard">
                      <div>
                        <label>{t("TIMEZONE")} </label>
                      </div>
                      <TimezonePicker
                        value={timezone}
                        inputProps={{ placeholder: "Select Timezone...", name: "timezone" }}
                        onChange={(timezoneName) => {
                          setTimezone(timezoneName);
                          validateForm();
                        }}
                      />
                    </div>
                    <div className="lineInputs">
                      <p>
                        {t("CURRENT_TIME")}
                        <br /> {t("IN_THIS_TIMEZONE")}: {dataTimeZone}
                      </p>
                    </div>
                  </div>

                  <div>
                    <label>{t("ADDRESS")} </label>
                  </div>
                  <input
                    required
                    name="address"
                    value={address}
                    onChange={handleChange}
                    placeholder={t("ADDRESS_PLACEHOLDER")}
                  />

                  {affiliateInfo && (
                    <>
                      <div>
                        <label htmlFor="name">{t("ADDRESS") + " 02"}</label>
                      </div>
                      <input
                        type="text"
                        name="address2"
                        onChange={handleChange}
                        placeholder={t("ADDRESS") + " 02"}
                        value={affiliateTaxInformations.address2}
                      />

                      <div className="inputs">
                        <div className="lineInputs">
                          <div>
                            <label>{t("CITY")}</label>
                          </div>
                          <input
                            name="city"
                            style={{ width: 131 }}
                            onChange={handleChange}
                            value={affiliateTaxInformations.city}
                          />
                        </div>

                        <div className="lineInputs">
                          <div>
                            <label>{t("STATE")}</label>
                          </div>
                          <input
                            name="state"
                            style={{ width: 131 }}
                            onChange={handleChange}
                            value={affiliateTaxInformations.state}
                          />
                        </div>

                        <div className="lineInputs">
                          <div>
                            <label>{t("ZIPCODE")}</label>
                          </div>

                          <input
                            name="zipcode"
                            style={{ width: 131 }}
                            onChange={handleChange}
                            value={affiliateTaxInformations.zipcode}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {firstAccess === false && user?.role === "student" && (
                    <>
                      <div className="wrapperBlock">
                        <h4 className="textBlock">{t("CLASS_LINK")}</h4>
                      </div>

                      <div className="inputs selectClass">
                        <div className="lineInputs">
                          <InputForClassTool
                            tabindex="-1"
                            name="classTool"
                            readonly="readonly"
                            aria-disabled="true"
                            inputChange={handleChange}
                            data={{ value: classTool, required: false }}
                          />
                        </div>
                        <div className="lineInputs">
                          <div>
                            <label>{t("TOOL_ID")}</label>
                          </div>
                          <a href={classToolId} target="_blank" rel="noreferrer">
                            <div className="classToolId">{classToolId}</div>
                          </a>
                        </div>
                      </div>

                      {ruleDisplayNativeBilingue() && (
                        <>
                          <div className="wrapperBlock">
                            <h4 className="textBlock">{t("TEACHER")}</h4>
                          </div>

                          <div className="wrapperSelectTeacher">
                            <button
                              onClick={(e) => handleClickBilingueNativo(e, "nativo")}
                              className={`buttonSelectTeacher ${bilingueNativo.nativo && "buttonSelectTeacherActive"}`}
                            >
                              {t("NATIVE")}
                            </button>
                            <button
                              onClick={(e) => handleClickBilingueNativo(e, "bilingue")}
                              className={`buttonSelectTeacher ${
                                bilingueNativo.bilingue && "buttonSelectTeacherActive"
                              }`}
                            >
                              {t("BILINGUAL")}
                            </button>

                            <Popup
                              on={"hover"}
                              position={"right center"}
                              trigger={<img className="linguitoPNG" src={linguitoPNG} />}
                              style={{ width: 300, backgroundColor: "red" }}
                            >
                              <div style={{ width: 300 }}>
                                <p style={{ textAlign: "justify", color: "#555D67" }}>
                                  {t("MESSAGE_INFO_BILINGUE_NATIVO")}
                                </p>
                              </div>
                            </Popup>
                          </div>
                        </>
                      )}
                    </>
                  )}

                  {affiliateInfo && (
                    <>
                      <div className="wrapperBlock">
                        <h4 className="textBlock">{t("TAX_INFORMATION")}</h4>
                      </div>

                      <div className="wrapperTaxInformation">
                        <div className="inputs">
                          <div className="lineInputs">
                            <div>
                              <label>{t("FISCAL_DOCUMENT")}</label>
                            </div>
                            <select name="taxIdType" onChange={handleChange} value={affiliateTaxInformations.taxIdType}>
                              {allTaxIdType.map((item, i) => (
                                <option key={i} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="lineInputs">
                            <div className="labelEmpty">
                              <label>‎</label>
                            </div>

                            <input name="taxId" onChange={handleChange} value={affiliateTaxInformations.taxId} />
                          </div>
                        </div>
                      </div>

                      <div className="wrapperBlock">
                        <h4 className="textBlock">{t("PAYMENT")}</h4>
                      </div>

                      <div className="wrapperPayment">
                        <div className="lineInputs">
                          <div>
                            <label>{t("PAYMENT")}</label>
                          </div>
                          <select
                            name="paymentType"
                            value={paymentType}
                            onChange={(e) => setPaymentType(e.target.value)}
                          >
                            <option value="">{t("SELECT")}</option>
                            <option value="payoneer">Payoneer</option>
                            <option value="paypal">Paypal</option>
                            <option value="zelle">Zelle</option>
                            {/* {affiliateInfo?.user?.countryId === 212 && <option value="venmo">Venmo</option>} */}
                          </select>
                        </div>

                        <div className="lineInputs">
                          <label htmlFor="payment">{t("PAYMENT_ID")}</label>
                          <input
                            type="text"
                            name="paymentID"
                            value={paymentID}
                            placeholder={"ID"}
                            onChange={(e) => setPaymentID(e.target.value)}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {(user?.role === "student" || user?.role === "coordinator" || user?.role === "affiliate") && (
                    <div>
                      <div className="wrapperBlock">
                        <h4 className="textBlock">{t("LANGUAGE")}</h4>

                        {user?.role === "student" && (
                          <button name="addlanguage" className="addInput" onClick={(e) => addLanguage(e)}>
                            {t("ADD_LANGUAGE")} +
                          </button>
                        )}
                      </div>

                      <div
                        className="wrapperLanguage"
                        style={languages?.filter((item) => !item.isNative).length === 0 ? { marginBottom: 25 } : {}}
                      >
                        <div
                          className="languageMain"
                          style={languages?.filter((item) => !item.isNative).length === 0 ? { marginBottom: 25 } : {}}
                        >
                          <div>
                            <label>{t("NATIVE_LANGUAGE")}</label>
                          </div>
                          <div>
                            <select
                              name="language"
                              className="language inputMobile"
                              onChange={(e) => handleChangeList(e, 0)}
                              value={validationLanguageNative ? validationLanguageNative : ""}
                              disabled={user?.role === "affiliate" ? false : user?.role !== "student" ? true : null}
                            >
                              <option value="">{t("SELECT")}</option>
                              {globallanguages?.map(({ id, name }) => (
                                <option key={id} value={id}>
                                  {name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {languages?.filter((item) => !item.isNative).length !== 0 && <div className="divSeparation" />}

                        <div className="otherLanguage">
                          {languages?.filter((item) => !item.isNative).length !== 0 && (
                            <div className="wrapperLabel">
                              <label>{t("OTHER_LANGUAGE")}</label>
                            </div>
                          )}

                          <div className="wrapperOtherLanguage">
                            {languages
                              ?.filter((item) => !item.isNative)
                              ?.map((item, index) => {
                                if (user?.role === "student" || (index >= 0 && user?.role !== "student"))
                                  index = index + 1;
                                return (
                                  <div key={index}>
                                    <div style={{ marginTop: -13, display: "flex" }}>
                                      <select
                                        name="language"
                                        id={"language" + index}
                                        value={item.languageId}
                                        className="language inputMobile"
                                        onChange={(e) => handleChangeList(e, index)}
                                        disabled={user?.role !== "student" ? true : null}
                                      >
                                        <option value="">{t("SELECT")}</option>
                                        {globallanguages.map(({ id, name }) => (
                                          <option key={id} value={id}>
                                            {name}
                                          </option>
                                        ))}
                                      </select>

                                      {user?.role === "student" && (
                                        <button
                                          id={index}
                                          name="removelanguage"
                                          className="buttonRemovelanguage"
                                          onClick={(e) => removeLanguage(e, index)}
                                        >
                                          X
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {user?.role === "teacher" && (
                    <div>
                      <div className="wrapperBlock">
                        <h4 className="textBlock">{t("LANGUAGE")}</h4>
                      </div>

                      <div className="wrapperLanguage">
                        <div
                          style={
                            languagesTeacher?.filter((item) => !item.isNative).length === 0 ? { marginBottom: 25 } : {}
                          }
                        >
                          {languagesTeacher
                            .filter((item) => item.isNative)
                            .map((item, i) => (
                              <div key={i} className="languageMain">
                                <div>
                                  <label>{t("NATIVE_LANGUAGE")}</label>
                                </div>

                                <div>
                                  <select
                                    disabled
                                    name="language"
                                    value={item.languageId}
                                    className="language inputMobile"
                                  >
                                    <option value="">{t("SELECT")}</option>
                                    {globallanguages?.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            ))}
                        </div>

                        {languagesTeacher?.filter((item) => !item.isNative).length !== 0 && (
                          <div className="divSeparation" />
                        )}

                        <div className="otherLanguage">
                          {languagesTeacher?.filter((item) => !item.isNative).length !== 0 && (
                            <div className="wrapperLabel">
                              <label>{t("OTHER_LANGUAGE")}</label>
                            </div>
                          )}

                          <div className="wrapperOtherLanguage">
                            {languagesTeacher
                              .filter((item) => !item.isNative)
                              .map((item, index) => {
                                if (user?.role === "student" || (index >= 0 && user?.role !== "student"))
                                  index = index + 1;
                                return (
                                  <div key={index}>
                                    <div style={{ marginTop: -13, display: "flex" }}>
                                      <select
                                        disabled
                                        id={index}
                                        name="language"
                                        value={item.languageId}
                                        className="language inputMobile"
                                      >
                                        <option value="">{t("SELECT")}</option>
                                        {globallanguages.map(({ id, name }) => (
                                          <option key={id} value={id}>
                                            {name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div>
                    <div>
                      <label>{t("PASSWORD")}</label>
                    </div>
                    <button type="button" className="password" onClick={openModalPassword}>
                      {t("CHANGE_PASSWORD")}
                    </button>
                  </div>
                </form>
              </div>

              <div className="buttonSave">
                <button type="submit" onClick={handleSubmit}>
                  {t("BTN_SAVE")}
                </button>
              </div>
            </div>
          </div>
        </ManageAccountStyles>
      </section>

      <DialogModal opened={dialog.opened} title={dialog.title} onClose={dialog.onClose} buttonLabel="Ok">
        <p className="message">{dialog.message}</p>
      </DialogModal>

      <Dialog
        open={openalert}
        onClose={closeAlert}
        className="boxModal"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal">{alerttitle}</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="pass-dialog-description" className="boxModal">
            <span className="formulario">
              <span className="description">{alertdescription}</span>
            </span>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <div className="buttons">
            <button onClick={closeAlert} color="primary" autoFocus>
              {t("CLOSE")}
            </button>
          </div>
        </DialogActions>
      </Dialog>

      <ModalChangePassword id={user?.id} showModal={openmodalpass} setShowModal={setOpenModalPass} />
    </div>
  );
}

export default ManageAccount;
